<template>
  <Drawer
    :transfer="true"
    title="发起人"
    v-model="visible"
    placement="right"
    class="set_promoter"
    width="550px"
    :closable="false"
    :before-close="closeDrawer"
  >
    <div class="demo-drawer__content">
      <div class="promoter_content drawer_content">
        <Tabs value="name1" name="promoterTab">
          <TabPane label="设置发起人" name="name1" tab="promoterTab">
            <promoterInfo
              :list.sync="list"
              :promoterConfig.sync="promoterConfig"
              @open-person-modal="addPromoter"
              @open-department-modal="openDepartmentDialog"
              @open-role-modal="openRoleDialog"
            />
          </TabPane>
          <TabPane label="表单操作权限" name="name2" tab="promoterTab">
            <permissionInfo
              v-if="visible"
              ref="permissionInfoRef"
              :dataConfig="promoterConfig"
              :formOpAuthList="promoterConfig.formOpAuthList"
            />
          </TabPane>
        </Tabs>
      </div>
      <employees-dialog
        :multiple="true"
        :visible.sync="promoterVisible"
        :selected="list.person"
        @change="surePromoter"
      />
      <departmentDialog
        :multiple="true"
        :selected="list.department"
        :visible.sync="departmentVisible"
        @change="sureDepartment"
      />
      <roleDialog
        :multiple="true"
        :visible.sync="roleVisible"
        :selected="list.role"
        @change="sureRole"
      />
    </div>
    <div class="demo-drawer__footer clear">
      <Button @click="closeDrawer">取 消</Button>
      <Button type="primary" @click="savePromoter">确 定</Button>
    </div>
  </Drawer>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { employeesDialog, departmentDialog, roleDialog } from '../dialog';
import { promoterInfo, permissionInfo } from '../drawerInfo';
import { userTypeConfig } from './drawerConfig';
import preload from '../../plugins/preload';
export default {
  components: {
    employeesDialog,
    promoterInfo,
    permissionInfo,
    departmentDialog,
    roleDialog
  },
  data() {
    return {
      promoterConfig: {},
      list: {
        person: [],
        department: [],
        role: []
      },
      promoterVisible: false,
      departmentVisible: false,
      roleVisible: false,
      visible: false
    };
  },
  computed: {
    ...mapState('workflow', ['promoterDrawer', 'promoterConfig1'])
  },
  watch: {
    promoterConfig1(val) {
      this.promoterConfig = val.value;
      this.initSelect(val.value);
    },
    promoterDrawer(val) {
      this.visible = val;
    }
  },
  methods: {
    ...mapMutations('workflow', ['setPromoter', 'setPromoterConfig']),
    addPromoter() {
      // this.checkedList 暂时先不用
      this.promoterVisible = true;
    },
    openDepartmentDialog() {
      this.departmentVisible = true;
    },
    openRoleDialog() {
      this.roleVisible = true;
    },
    surePromoter(data) {
      this.list = { ...this.list, person: data };
      this.promoterVisible = false;
    },
    sureDepartment(data) {
      this.list = { ...this.list, department: data };
      this.departmentVisible = false;
    },
    sureRole(data) {
      this.list = { ...this.list, role: data };
      this.roleVisible = false;
    },
    savePromoter() {
      const permissionInfoDom = this.$refs.permissionInfoRef;
      const formOpAuthList = permissionInfoDom.getFormOpAuthListData();
      this.promoterConfig.formOpAuthList = formOpAuthList;
      const { userType } = this.promoterConfig;
      const { listName } = userTypeConfig[userType];
      const nodeUserList = this.list[listName];
      this.promoterConfig.nodeUserList = nodeUserList;
      this.promoterConfig.nodeExecUsers = nodeUserList.map(item => {
        // 当是部门的时候，后端要 relationId
        return userType == 2 ? item.relationId : item.id;
      });
      this.promoterConfig.error = !preload.setPromoterStr(this.promoterConfig);
      this.setPromoterConfig({
        value: this.promoterConfig,
        flag: true,
        id: this.promoterConfig1.id
      });
      this.closeDrawer();
    },
    closeDrawer() {
      this.setPromoter(false);
    },
    initSelect(config) {
      const arr = ['', 'person', 'department', 'role'];
      const type = arr[config.userType];
      arr.forEach(item => {
        if (item == type) {
          this.list[item] = config.nodeUserList;
        } else {
          this.list[item] = [];
        }
      });
      this.list[type] = config.nodeUserList;
    }
  }
};
</script>
<style lang="less">
.set_promoter {
  .promoter_content {
    padding: 0 20px;

    .Button {
      margin-bottom: 20px;
    }

    p {
      padding: 18px 0;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
    }
  }
}
</style>
